import { liveReplays } from "@/mocks/chigua";

export default function LivesSection() {
  return (
    <section id="lives" className="scroll-mt-28 bg-paper">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6">
        <div className="mb-9 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-amber/20 px-3 py-1 text-xs font-bold text-[#a96f1f]">
              <i className="ri-live-line" />
              直播回放 · 全程不漏
            </span>
            <h2 className="mt-3 font-display-x text-3xl font-black md:text-4xl">
              直播回放 · 错过也能补全程
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-ink/60 md:text-base">
              平台保存的完整节目回放，画质稳定、可倍速。错过直播不用翻别人录屏，在这里直接回看整场。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {liveReplays.map((l, i) => (
            <a
              key={l.title}
              href="#lives"
              className="group relative overflow-hidden rounded-3xl bg-sand"
            >
              <div className="relative h-72 w-full overflow-hidden md:h-80">
                <img
                  src={l.cover}
                  alt={l.title}
                  className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
                <span className="absolute left-4 top-4 flex items-center gap-1.5 rounded-full bg-paper/85 px-3 py-1 text-xs font-bold text-ink backdrop-blur">
                  <i
                    className={`ri-play-circle-line ${
                      i === 0 ? "text-ember" : "text-moss"
                    }`}
                  />
                  {l.status}
                </span>
                <span className="absolute right-4 top-4 rounded-full bg-ink/60 px-3 py-1 text-[11px] text-cream backdrop-blur">
                  {l.date}
                </span>
                <span className="absolute bottom-4 left-4 right-4 flex items-end justify-between gap-3">
                  <h3 className="font-display-x text-xl font-bold text-cream md:text-2xl">
                    {l.title}
                  </h3>
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-paper text-ember transition group-hover:scale-110">
                    <i className="ri-play-fill text-xl" />
                  </span>
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-5 flex items-center gap-3 rounded-2xl border border-dashed border-clay/40 bg-cream px-5 py-4">
          <i className="ri-information-line text-amber" />
          <p className="text-sm text-ink/65">
            回放画质与原直播一致，支持倍速与进度拖拽。因平台差异，部分场次回放可能延迟 1–2 小时。
          </p>
        </div>
      </div>
    </section>
  );
}